import { sanitizeRichTextHtml } from "./sanitise.js";
import { prepareHtmlLinks } from "./url.js";

export const DEFAULT_HUBSPOT_SUCCESS_MESSAGE_HTML = "<p>Thank you for your submission!</p>";

function hasHtmlTags(content: string): boolean {
    return /<\/?[a-z][a-z0-9-]*(\s[^<>]*)?>/i.test(content);
}

function escapeHtml(content: string): string {
    return content
        .replaceAll("&", "&amp;")
        .replaceAll("<", "&lt;")
        .replaceAll(">", "&gt;")
        .replaceAll('"', "&quot;")
        .replaceAll("'", "&#39;");
}

function convertPlainTextToHtml(content: string): string {
    const withUnixNewlines = content.replace(/\r\n?/g, "\n").trim();
    if (!withUnixNewlines) return "";

    const paragraphs = withUnixNewlines
        .split(/\n{2,}/)
        .map((paragraph) => paragraph.trim())
        .filter(Boolean);

    if (paragraphs.length === 0) return "";

    return paragraphs
        .map((paragraph) => `<p>${escapeHtml(paragraph).replaceAll("\n", "<br>")}</p>`)
        .join("");
}

export function sanitiseHubspotSuccessMessage(content: string | null | undefined): string {
    const trimmed = content?.trim() || "";
    if (!trimmed) return DEFAULT_HUBSPOT_SUCCESS_MESSAGE_HTML;

    const html = hasHtmlTags(trimmed) ? trimmed : convertPlainTextToHtml(trimmed);
    const sanitised = prepareHtmlLinks(sanitizeRichTextHtml(html));

    return sanitised || DEFAULT_HUBSPOT_SUCCESS_MESSAGE_HTML;
}
